import { Flex, IconButton } from '@utilitywarehouse/hearth-react';
import {
  ChevronLeftSmallIcon,
  ChevronRightSmallIcon,
} from '@utilitywarehouse/hearth-react-icons';
import clsx from 'clsx';

import './styles.scss';

interface CarouselControlsProps {
  count: number;
  activeIndex: number;
  onSelect: (index: number) => void;
  onPrev?: () => void;
  onNext?: () => void;
  itemLabel?: string;
  className?: string;
}

const CarouselControls = ({
  count,
  activeIndex,
  onSelect,
  onPrev,
  onNext,
  itemLabel = 'item',
  className,
}: CarouselControlsProps) => {
  return (
    <div className={clsx('carousel-controls', className)}>
      <Flex alignItems="center" justifyContent="between" width="100%">
        {onPrev && (
          <IconButton
            variant="ghost"
            size="sm"
            label={`Previous ${itemLabel}`}
            onClick={onPrev}
          >
            <ChevronLeftSmallIcon />
          </IconButton>
        )}

        <Flex alignItems="center" gap="100" paddingX="100">
          {Array.from({ length: count }).map((_, index) => (
            <button
              key={index}
              type="button"
              className={`carousel-controls__dot${
                index === activeIndex ? ' carousel-controls__dot--active' : ''
              }`}
              aria-label={`Go to ${itemLabel} ${index + 1} of ${count}`}
              aria-current={index === activeIndex}
              onClick={() => onSelect(index)}
            />
          ))}
        </Flex>

        {onNext && (
          <IconButton
            variant="ghost"
            size="sm"
            label={`Next ${itemLabel}`}
            onClick={onNext}
          >
            <ChevronRightSmallIcon />
          </IconButton>
        )}
      </Flex>
    </div>
  );
};

export { CarouselControls };
export type { CarouselControlsProps };
